import { omitBy, isNil, uniq } from 'lodash-es'
import { useI18n } from 'vue-i18n'

export function useContextFields(document, text, elements, matches) {
  const { t } = useI18n()
  return omitBy({
    [t('result.context.header.document.referencia_bibliografica')]: document.referencia_bibliografica,
    [t('result.context.header.document.bibliografia_titulo')]: document.bibliografia_titulo,
    [t('result.context.header.document.fecha_visible')]: document.fecha_visible,
    [t('result.context.header.document.otorgante')]: t(`otorgante.${document.otorgante}`),
    [t('result.context.header.document.paginas')]: document.paginas,
  }, v => v === '' || isNil(v))
}
